import styled from 'styled-components'

import { helpers } from 'styles'

export const Container = styled.footer`
	box-shadow: inset 0 1px 0 ${helpers.color.pageIndent};
	display: flex;
	align-items: center;
	justify-content: space-around;
	height: fit-content;
`
